import { DialogActions } from '@mui/material';
import React from 'react';
import { themeColors } from '../JuvareTheme';
/**
 * A component rendered at the bottom of a slideout, typically used for displaying action buttons.
 *
 * @param {ModalSlideoutActionsProps} props - Component props.
 * @returns {React.ReactElement} The rendered DialogActions element with optional children.
 */
export const ModalSlideoutActions = (props) => {
    return (React.createElement(DialogActions, { sx: {
            borderTop: `1px solid ${themeColors.border.main}`,
            position: 'sticky',
            bottom: 0,
            p: 0,
            background: themeColors.surface.primary,
        }, "data-test": props['data-test'] }, props.children));
};
